import { DragHandle } from '@creditornot/cb-icons';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import styled, { css } from 'styled-components';

import { Typography as T } from 'common/typography';

const HEADER_BREAKPOINT = 800;
const SIDEPANEL_MARGIN = 24;

export const HeaderWrapper = styled.div<{ showPointer?: boolean }>`
  /* Makes the option row full-bleed */
  margin-inline: -${SIDEPANEL_MARGIN}px;
  /* Set wrapper background color to solid color so hover style doesn't make it transparent */
  background-color: ${cbSemanticCssVars.surfaceMain};
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};

  ${({ showPointer }) =>
    !!showPointer &&
    css`
      cursor: pointer;
    `}
`;

export const Header = styled.div<{ showHoverStyles?: boolean; $hidden?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 104px;
  padding: 24px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  transition: background-color 100ms;

  ${({ showHoverStyles }) =>
    !!showHoverStyles &&
    css`
      &:hover {
        /* ignore-color */
        background-color: ${colors.pepper8};
      }
    `}

  ${({ hidden }) =>
    hidden &&
    css`
      opacity: 0;
    `}
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  margin-inline-end: 16px;
  overflow: hidden;

  @media (min-width: ${HEADER_BREAKPOINT}px) {
    margin-inline-end: 32px;
  }

  @media (width >= 1000px) {
    margin-inline-end: 64px;
  }

  @media (width >= 1200px) {
    margin-inline-end: 120px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`;

export const HeaderNameAndChoices = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
`;

export const HeaderTags = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${HEADER_BREAKPOINT}px) {
    flex-direction: row;
  }
`;

export const HeaderNameAndTags = styled.div`
  display: flex;
  margin-block-end: 4px;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: ${HEADER_BREAKPOINT}px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const HeaderName = styled(T.Body3).attrs({ fontWeight: 'bold' })`
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const HeaderOptionTypeTag = styled(Tag).attrs({ size: 'small', uppercase: true, variant: 'lightBlack' })`
  margin-block-start: 4px;

  @media (min-width: ${HEADER_BREAKPOINT}px) {
    margin-inline-start: 12px;
    margin-block-start: 0;
  }
`;

export const HeaderDisabledChoicesTag = styled(Tag).attrs({ size: 'small', uppercase: true, variant: 'lightRed' })`
  margin-block-start: 4px;

  @media (min-width: ${HEADER_BREAKPOINT}px) {
    margin-inline-start: 12px;
    margin-block-start: 0;
  }
`;

export const OptionBindingDragHandle = styled(DragHandle).attrs({ width: 14 })`
  cursor: grab;
  margin-inline-end: 12px;
  flex-shrink: 0;
  fill: ${cbSemanticCssVars.textPrimary};
`;
